import React, {Component} from 'react';
import {connect} from 'react-redux';
import SelectRadioGroup from '../../../Shared/components/Forms/selects/SelectRadioGroup';
import SelectRadioGroup2 from '../../../Shared/components/Forms/selects/SelectRadioGroup2';
import SimpleSelect from '../../../Shared/components/Forms/selects/SimpleSelect';
import SwitchButton from '../../../Shared/components/Forms/SwitchButton';
import {
    changeAvanzadoFilter,
    changeCaractersAnimalSeleccionados,
    changeChipSeleccionado,
    changeColoresAnimalSeleccionados,
    changeEdadesSeleccionado,
    changeEmailSubscription,
    changeEspecieSeleccionada,
    changeEstadoSeleccionado,
    changeEstadoUrgenteSeleccionado,
    changePostalCode,
    changePPPSeleccionado,
    changeRazaSeleccionada,
    changeSexoSeleccionado,
    changeTamaniosSeleccionado,
    resetTamaniosSeleccionado,
    changeVacunaSeleccionada,
    loadCaractersAnimal,
    loadColoresAnimal,
    loadEstadosAnimal,
    loadRaza
} from '../../actions/actionsFilterAnimals';
import {checkIsLogin} from "../../../AdminProtectora/actions/actionsAdmin";
import {arrayEquals} from "../../../../Utils/utils";
import NewSimpleSelect from "../../../Shared/components/Forms/selects/NewSimpleSelect";
import MultiSelect from "../../../Shared/components/Forms/selects/MultiSelect";


class AnimalFilter extends Component {

    constructor(props) {
        super(props);
        // this.props.isLogin();

        this.state = {
            okPolica: false,
            emailSubscription: '',
            postalCode: ''
        }

        this.configSubscription = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateSubscription",
            iconSpan: "icon-subscription las la-envelope",
            columns: "",
            id: "email",
            type: "text",
            placeHolder: "Email",
            methodChange: this.changeEmailSubscription.bind(this)
        };
        this.configCodigoPostal = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateSubscription",
            iconSpan: "icon-subscription las la-address-card",
            columns: "",
            id: "postalCode",
            type: "text",
            placeHolder: "Código postal",
            methodChange: this.changePostalCode.bind(this)
        };

        this.configSelectRadioGroupEspecie = {
            mainId: "especie-filtro",
            mainLabel: "Especie",
            selected: this.props.filter.especieSeleccionada,
            idDiv: "select-home-second",
            classDiv: "form-group",
            showLabel: false,
            infoSelect: [
                {
                    icon: "las la-lg la-dog",
                    id: "switch_Perro",
                    value: "perro",
                    label: "Perro",
                    name: "switch_raza"
                },
                {
                    icon: "las la-lg la-paw",
                    id: "switch_Ambos_especie",
                    value: "ambos",
                    label: "Ambos",
                    name: "switch_raza",
                },
                {
                    icon: "las la-lg la-cat",
                    id: "switch_Gato",
                    value: "gato",
                    label: "Gato",
                    name: "switch_raza",
                }
            ],
            methodChange: this.changeEspecie.bind(this)
        };

        this.configSelectRadioGroupSexo = {
            mainId: "sexo-filter",
            mainLabel: "Sexo",
            selected: this.props.filter.sexoSeleccionado,
            idDiv: "select-home-second",
            classDiv: "form-group",
            showLabel: false,
            infoSelect: [
                {
                    icon: "la la-mars",
                    id: "switch_Macho",
                    value: "M",
                    label: "Macho",
                    name: "switch_sexo"
                },
                {
                    icon: "la la-transgender",
                    id: "switch_Ambos_sexo",
                    value: "MH",
                    label: "Ambos",
                    name: "switch_sexo"
                },
                {
                    icon: "la la-venus",
                    id: "switch_Hembra",
                    value: "H",
                    label: "Hembra",
                    name: "switch_sexo"
                }
            ],
            methodChange: this.changeSexo.bind(this)
        };

        this.configRazasMultiselect = {
            id: "idRaza",
            idSelect: "raza",
            collSize: "",
            initialValue: 0,
            seleccionado: this.props.filter.razasSeleccionadas,
            placeHolder: "Escribe y busca razas",
            all: {
                label: "TODAS",
                value: "all"
            },
            methodChange: this.OLD_changeRaza.bind(this)
        };

        this.configSimpleSelectRazas = {
            id: "idFilterRazas",
            collSize: "",
            seleccionado: this.props.filter.razaSeleccionada,
            placeHolder: "Escribe una raza",
            all: {
                label: "TODAS",
                value: "all"
            },
            methodChange: this.changeRaza.bind(this)
        };

        this.configSelectRadioGroupTamanios = {
            mainId: "tamanios-filter",
            mainLabel: "Tamaño",
            selected: this.props.filter.tamaniosSeleccionados,
            showLabel: false,
            infoSelect: [
                {
                    value: "MP",
                    label: "Muy pequeño"
                },
                {
                    value: "P",
                    label: "Pequeño"
                },
                {
                    value: "M",
                    label: "Mediano"
                },
                {
                    value: "G",
                    label: "Grande"
                },
                {
                    value: "MG",
                    label: "Muy grande"
                }
            ],
            methodChange: this.changeTamanio.bind(this)
        };

        this.configSelectRadioGroupEdades = {
            mainId: "edad-filter",
            mainLabel: "Edad",
            selected: this.props.filter.edadesSeleccionadas,
            showLabel: false,
            infoSelect: [
                {
                    value: "C",
                    label: "Cachorro"
                },
                {
                    value: "J",
                    label: "Joven"
                },
                {
                    value: "A",
                    label: "Adulto"
                },
                {
                    value: "M",
                    label: "Mayor"
                },
                {
                    value: "AB",
                    label: "Abuelo"
                }
            ],
            methodChange: this.changeEdad.bind(this)
        };
        // this.props.varsData.id_protectora
        if (this.props.access.isLogin
            && this.props.access.id === this.props.varsData.id_protectora
            && this.props.filterControl === "filtersControlProtectora" &&
            this.props.isAdminAnimals) {
            this.configEstados = {
                id: "idEstados",
                idSelect: "estados",
                collSize: "",
                seleccionado: this.props.filter.estadoAnimalSeleccionado,
                placeHolder: "Estados",
                methodChange: this.changeEstado.bind(this)
            };
        } else {
            this.configEstadoUrgente = {
                id: "estadoUrgente",
                classMain: "mb-3",
                classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
                classCheckbox: "checkbox-toggle-switch",
                checkedLabel: "Si",
                uncheckedLabel: "No",
                seleccionado: this.props.filter.estadoUrgenteSeleccionado,
                methodChange: this.changeEstadoUrgente.bind(this)
            };
        }

        this.configColores = {
            id: "idColores",
            idSelect: "color",
            collSize: "",
            seleccionado: this.props.filter.coloresAnimalSeleccionados,
            placeHolder: "Escribe y busca",
            initialValue: 0,
            all: {
                text: "TODOS"
            },
            methodChange: this.changeColores.bind(this)
        };

        this.configCaracters = {
            id: "idCaracters",
            idSelect: "caracter",
            collSize: "",
            seleccionado: this.props.filter.caractersAnimalSeleccionados,
            placeHolder: "Escribe y busca",
            initialValue: 0,
            all: {
                text: "TODOS"
            },
            methodChange: this.changeCaracters.bind(this)
        };

        this.configChip = {
            id: "chip",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.props.filter.chipSeleccionado,
            methodChange: this.changeChip.bind(this)
        };

        this.configVacuna = {
            id: "vacuna",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.props.filter.vacunaSeleccionada,
            methodChange: this.changeVacuna.bind(this)
        };

        this.configPPP = {
            id: "ppp",
            classMain: "mb-3",
            classCheckboxMain: "checkbox-toggle checkbox-toggle-lg",
            classCheckbox: "checkbox-toggle-switch",
            checkedLabel: "Si",
            uncheckedLabel: "No",
            Seleccionado: this.props.filter.pppSeleccionado,
            methodChange: this.changePPP.bind(this)
        };

        this.getAnimals = this.getAnimals.bind(this);
        // this.changeEspecie = this.changeEspecie.bind(this);
        // this.changeSexo = this.changeSexo.bind(this);
        // this.saveSubscription = this.saveSubscription.bind(this);
        this.handleOkPolitica = this.handleOkPolitica.bind(this);

    }

    handleOkPolitica(checked) {
        this.setState({
            okPolitica: checked
        });
    }

    //----------------
    //Observer changes
    //----------------

    changeEspecie(raza) {
        this.props.changeEspecieSeleccionada(raza, this.props.filterControl);
        this.props.changeRazaSeleccionada(undefined, this.props.filterControl);
        this.getAnimals();
    }

    changeSexo(sexo) {
        this.props.changeSexoSeleccionado(sexo, this.props.filterControl);
        this.getAnimals();
    }

    changeTamanio(tamanio) {
        console.log("AnimalFilter::changeTamanio(tamanio = " + tamanio + ")")
        console.log("this.props.filter.tamaniosSeleccionados = [" + this.props.filter.tamaniosSeleccionados+"]")
        this.props.changeTamaniosSeleccionado(tamanio, this.props.filterControl);
        this.getAnimals();
        console.log("this.props.filter.tamaniosSeleccionados = [" + this.props.filter.tamaniosSeleccionados+"]")
    }

    changeEdad(edad) {
        this.props.changeEdadesSeleccionado(edad, this.props.filterControl);
        this.getAnimals();
    }

    OLD_changeRaza(razas) {
        console.log("AnimalFilter::OLD_changeRaza(razas = " + razas + ")")
        debugger
        if (!arrayEquals(razas, this.props.filter.razasSeleccionadas)) {
            this.props.changeRazaSeleccionada(razas, this.props.filterControl);
            this.getAnimals();
        }

    }

    changeRaza(raza) {
        if (raza !== this.props.filter.razaSeleccionada) {
            this.props.resetTamaniosSeleccionado(this.props.filterControl);
            this.props.changeRazaSeleccionada(raza, this.props.filterControl);
            this.getAnimals();
        }
    }

    changeEstado(estado) {
        if (!arrayEquals(estado, this.props.filter.estadoAnimalSeleccionado)) {
            this.props.changeEstadoSeleccionado(estado, this.props.filterControl);
            this.getAnimals();
        }
    }

    changeEstadoUrgente(estadoUrgente) {
        this.props.changeEstadoUrgenteSeleccionado(estadoUrgente, this.props.filterControl);
        this.getAnimals();
    }


    changeColores(colores) {
        if (!arrayEquals(colores, this.props.filter.coloresAnimalSeleccionados)) {
            this.props.changeColoresAnimalSeleccionados(colores, this.props.filterControl);
            this.getAnimals();
        }

    }

    changeCaracters(caracters) {
        if (!arrayEquals(caracters, this.props.filter.caractersAnimalSeleccionados)) {
            this.props.changeCaractersAnimalSeleccionados(caracters, this.props.filterControl);
            this.getAnimals();
        }
    }

    changeChip(chip) {
        this.props.changeChipSeleccionado(chip, this.props.filterControl);
        this.getAnimals();
    }

    changeVacuna(vacuna) {
        this.props.changeVacunaSeleccionada(vacuna, this.props.filterControl);
        this.getAnimals();
    }

    changePPP(ppp) {
        this.props.changePPPSeleccionado(ppp, this.props.filterControl);
        this.getAnimals();
    }

    changeAvanzado() {
        this.props.changeAvanzadoFilter(this.props.filterControl);
    }

    changeEmailSubscription(value) {
        this.setState({
            emailSubscription: value
        })
        this.props.changeEmailSubscription(value);
    }

    changePostalCode(value) {
        this.setState({
            postalCode: value
        })
        this.props.changePostalCode(value);
    }

    // saveSubscription() {
    //     const that = this;
    //     if (this.validateEmail(this.state.emailSubscription)) {
    //         if (this.props.filter.razasSeleccionadas && this.props.filter.razasSeleccionadas.length > 0 || (this.props.filter.razasSeleccionadas.findIndex(x => x === "TODAS") >= 0 && this.props.filter.razasSeleccionadas.length > 1) || (this.props.filter.tamaniosSeleccionados && this.props.filter.tamaniosSeleccionados.length > 0) || (this.props.filter.edadesSeleccionadas && this.props.filter.edadesSeleccionadas.length > 0)) {
    //             let peticion = persistSubscription(this.state.emailSubscription, this.props.filter);
    //             peticion.done(function (data, textStatus, jqXHR) {
    //                 Alert.success('Guardado', {
    //                     position: 'top-right',
    //                     effect: 'slide',
    //                     timeout: 3000,
    //                     customFields: {
    //                         messageItem: 2,
    //                         showIconClosed: true,
    //                         icon: "las la-2x la-thumbs-up"
    //                     }
    //                 });
    //                 $("#postalCode").val("");
    //                 $("#email").val("");
    //                 that.handleOkPolitica(false);
    //                 that.changeEmailSubscription("");
    //                 that.changePostalCode("");
    //             }).fail(function (jqXHR, textStatus, errorThrown) {
    //                 Alert.error('Error en la suscripción', {
    //                     position: 'top-right',
    //                     effect: 'slide',
    //                     timeout: 3000,
    //                     customFields: {
    //                         messageItem: 2,
    //                         showIconClosed: true,
    //                         icon: "las la-2x la-exclamation-triangle"
    //                     }
    //                 });
    //             });
    //         } else {
    //             Alert.warning('Es necesario filtrar por alguna raza, tamaño o edad como mínimo', {
    //                 position: 'top-right',
    //                 effect: 'slide',
    //                 timeout: 3000,
    //                 customFields: {
    //                     messageItem: 2,
    //                     showIconClosed: true,
    //                     icon: "las la-2x la-exclamation-triangle"
    //                 }
    //             });
    //         }
    //     } else {
    //         Alert.warning('Email no válido', {
    //             position: 'top-right',
    //             effect: 'slide',
    //             timeout: 3000,
    //             customFields: {
    //                 messageItem: 2,
    //                 showIconClosed: true,
    //                 icon: "las la-2x la-exclamation-triangle"
    //             }
    //         });
    //     }
    // };

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    //----------------

    getAnimals() {
        this.props.loadData(0);
        this.props.loader();
    }


    render() {
        // console.log("AnimalFilter::render()");
        let classBotonAvanzado;
        let labelBotonAvanzado;
        if (this.props.avanzado) {
            classBotonAvanzado = "las la-lg la-minus";
            labelBotonAvanzado = "Menos filtros";
        } else {
            classBotonAvanzado = "las la-lg la-plus";
            labelBotonAvanzado = "Más filtros";
        }
        return (
            <div>
                <div className="icon-wrapper btn-outline-primary">
                    <div className="button-filter">
                        <span/>
                        <div className="icon-wrapper-text">Filtrar</div>
                    </div>
                    <div className="quick-filter">
                        <a onClick={() => {
                            this.changeEspecie("perro")
                        }}
                           className={"btn btn-outline-primary btn-quick-filter-especie " + ((this.props.filter.especieSeleccionada === "perro") ? " btn-active" : "")}>Perros</a>

                        <a onClick={() => {
                            this.changeEspecie("gato")
                        }}
                           className={"btn btn-outline-primary btn-quick-filter-especie" + ((this.props.filter.especieSeleccionada === "gato") ? " btn-active" : "")}>Gatos</a>
                    </div>
                </div>
                <div id="animals-filter" className=" sidebar-filter-default">

                    <div className="sidebar-filter-default__section filter-result">
                        <button id="btn-result-filter"
                                className="btn btn-primary btn-block btn-lg index-resume__search-button button-filter">
                            <span className={"las la-lg la-search"}/>
                            <span
                                className="text"> Ver {(this.props.totalRecord === 1) ? this.props.totalRecord + " resultado" : this.props.totalRecord + " resultados"}</span>
                        </button>
                    </div>
                    <div className="sidebar-filter-default__section">
                        <h4 className="sidebar-filter-default__title">Filtrar <span className="las la-filter"/>
                            <span className="sidebar-filter-default__result">({this.props.totalRecord})</span></h4>
                    </div>
                    {/*{this.props.filterControl === "reducerFiltersControl"*/}
                    {/*&&*/}
                    {/*<div className="sidebar-filter-default__section">*/}
                    {/*    <h6>Guardar búsqueda</h6>*/}
                    {/*    <p>Recibe avisos de nuevos anuncios que coincidan con este filtro</p>*/}
                    {/*    <Input*/}
                    {/*        configInput={this.configSubscription}*/}
                    {/*    />*/}
                    {/*    {this.state.emailSubscription !== "" && (*/}
                    {/*        <div>*/}
                    {/*            <Input*/}
                    {/*                configInput={this.configCodigoPostal}*/}
                    {/*            />*/}
                    {/*            <PoliticaCheckButton onOkPolitica={this.handleOkPolitica}/>*/}
                    {/*        </div>*/}
                    {/*    )}*/}
                    {/*    <button*/}
                    {/*        className="btn btn-filter btn-outline-primary listing-houses__item-view-link"*/}
                    {/*        type="button"*/}
                    {/*        disabled={!this.state.okPolitica}*/}
                    {/*        onClick={this.saveSubscription}*/}
                    {/*    >*/}
                    {/*        <span className="las la-lg la-bell"/> Guardar búsqueda*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                    {/*}*/}
                    <div className="sidebar-filter-default__section">
                        <h6 className="sidebar-filter-default__heading">Qué buscas</h6>
                        {/*<div id="especie-filtro" className="radio-group-toggle">*/}
                        <SelectRadioGroup
                            configSelectRadioGroup={this.configSelectRadioGroupEspecie}
                        />
                        {/*</div>*/}
                    </div>
                    <hr/>
                    {this.props.access.isLogin
                        && this.props.access.id === this.props.varsData.id_protectora
                        && this.props.filterControl === "filtersControlProtectora" &&
                        this.props.isAdminAnimals &&
                        <div className="sidebar-filter-default__section animated-400ms fadeIn">
                            <h6 className="sidebar-filter-default__heading">Estado</h6>
                            <SimpleSelect
                                configSearch={this.configEstados}
                                data={this.props.estadosAnimal.map((estado) => {
                                    return estado.text;
                                })}
                            />
                        </div>
                    }
                    <div className="sidebar-filter-default__section">
                        <h6 className="sidebar-filter-default__heading">Raza</h6>
                        {/*{<MultiSelect*/}
                        {/*    configSearch={this.configRazasMultiselect}*/}
                        {/*    data={this.props.razasEspecieSelecionada.map(r => {*/}
                        {/*        return {...r, text: r.label}*/}
                        {/*    })}*/}
                        {/*    seleccionados={this.configRazasMultiselect.seleccionado}*/}
                        {/*/>}*/}
                        <NewSimpleSelect
                            configSearch={{
                                ...this.configSimpleSelectRazas,
                                seleccionado: this.props.filter.razaSeleccionada,
                            }}
                            data={this.props.razasEspecieSelecionada}
                        />
                    </div>
                    <hr/>

                    <div className="sidebar-filter-default__section">
                        <h6 className="sidebar-filter-default__heading">Sexo</h6>
                        <SelectRadioGroup
                            configSelectRadioGroup={this.configSelectRadioGroupSexo}
                        />
                    </div>
                    <hr/>

                    <div className="sidebar-filter-default__section">
                        <h6 className="sidebar-filter-default__heading">Edad</h6>
                        <SelectRadioGroup2
                            configSelectRadioGroup={this.configSelectRadioGroupEdades}
                        />
                    </div>
                    <hr/>
                    {!this.props.filter.razaSeleccionada &&
                        <div className="sidebar-filter-default__section">
                            <h6 className="sidebar-filter-default__heading">Tamaño</h6>
                            <SelectRadioGroup2
                                configSelectRadioGroup={{...this.configSelectRadioGroupTamanios, selected:this.props.filter.tamaniosSeleccionados}}
                            />
                        </div>
                    }

                    {this.props.avanzado &&
                        <div className="avanzado">
                            {!(this.props.access.isLogin
                                    && this.props.access.id === this.props.varsData.id_protectora
                                    && this.props.filterControl === "filtersControlProtectora" &&
                                    this.props.isAdminAnimals) &&
                                <div className="sidebar-filter-default__section animated-400ms fadeIn">
                                    <h6 className="sidebar-filter-default__heading">Estado urgente</h6>
                                    <SwitchButton
                                        configSwitch={this.configEstadoUrgente}
                                    />
                                </div>
                            }
                            <hr/>

                            <div className="sidebar-filter-default__section animated-400ms fadeIn">
                                <h6 className="sidebar-filter-default__heading">Color</h6>
                                <MultiSelect
                                    configSearch={this.configColores}
                                    data={this.props.coloresAnimal}
                                />
                            </div>
                            <hr/>

                            {/*<div className="sidebar-filter-default__section animated-400ms fadeIn">*/}
                            {/*    <h6 className="sidebar-filter-default__heading">Carácter</h6>*/}
                            {/*    <MultiSelect*/}
                            {/*        configSearch={this.configCaracters}*/}
                            {/*        data={this.props.caractersAnimal}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {/*<hr/>*/}

                            <div className="sidebar-filter-default__section animated-400ms fadeIn">
                                <h6 className="sidebar-filter-default__heading">Chip</h6>
                                <SwitchButton
                                    configSwitch={this.configChip}
                                />
                            </div>
                            <hr/>

                            <div className="sidebar-filter-default__section animated-400ms fadeIn">
                                <h6 className="sidebar-filter-default__heading">Vacunas</h6>
                                <SwitchButton
                                    configSwitch={this.configVacuna}
                                />
                            </div>
                            <hr/>

                            <div className="sidebar-filter-default__section animated-400ms fadeIn">
                                <h6 className="sidebar-filter-default__heading">Requiere licencia PPP</h6>
                                <SwitchButton
                                    configSwitch={this.configPPP}
                                />
                            </div>
                        </div>
                    }
                    <button onClick={() => this.changeAvanzado()} id="filtro-avanzado"
                            className="btn btn-primary btn-block btn-lg index-resume__search-button">
                        <span className={classBotonAvanzado}/>
                        <span className="text">{labelBotonAvanzado}</span>
                    </button>
                </div>
            </div>
        );
    }

    componentWillMount() {
        // debugger
        if (this.props.razasAnimales?.perro === undefined || this.props.razasAnimales.perro.length === 0) {
            this.props.loadRaza("perro");
        }
        if (this.props.razasAnimales?.gato === undefined || this.props.razasAnimales.gato.length === 0) {
            this.props.loadRaza("gato");
        }
        // if (this.props.razasPerro === undefined || this.props.razasPerro.length === 0) {
        //     this.props.loadRaza("perro");
        // }
        // if (this.props.razasGato === undefined || this.props.razasGato.length === 0) {
        //     this.props.loadRaza("gato");
        // }
        if (this.props.estadosAnimal === undefined || this.props.estadosAnimal.length === 0) {
            this.props.loadEstadosAnimal();
        }
        if (this.props.coloresAnimal === undefined || this.props.coloresAnimal.length === 0) {
            this.props.loadColoresAnimal();
        }
        if (this.props.caractersAnimal === undefined || this.props.caractersAnimal.length === 0) {
            this.props.loadCaractersAnimal();
        }
    };

    componentDidMount() {
        // $('#animals-filter').addClass('animated-0s fadeInLeft');
        this.changeEmailSubscription("");
        const btnFilterResult = $('#btn-result-filter');
        const divFilterResult = $('.filter-result');
        const elemIconWrapper = $('.icon-wrapper');

        $(window).on('scroll', function () {
            //el boton está visible sobre el filtro activo y un poco más de margen
            let topIconWrapper = (elemIconWrapper && elemIconWrapper.offset() && elemIconWrapper.offset().top) ? elemIconWrapper.offset().top : 0
            if (($(window).scrollTop() + $(window).height() > $('#animals-filter').outerHeight() + topIconWrapper + $(window).height() ||
                ($(window).scrollTop() + $(window).height() < topIconWrapper + $(window).height() - 100))) {
                // btnFilterResult.hide()
                btnFilterResult.css("display", "none");
            } else {
                // btnFilterResult.show()
                btnFilterResult.css("display", "block");

            }
            if ($(window).scrollTop() <= 70) {
                divFilterResult.css({top: (66 - $(window).scrollTop()) + 'px'});
            }

            if ($(window).scrollTop() > 70 && divFilterResult.css('top') !== "0px") {
                divFilterResult.css({top: 0 + 'px'});
            }
        });

        $('.button-filter').on("click", (e) => {
            let burguer = $(e.currentTarget);
            if (burguer.hasClass("clicked")) {
                $('#animals-filter').hide();
            } else {
                $('#animals-filter').show();
            }
            $('.button-filter').toggleClass("clicked");

            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: $('#animals-list').offset().top}, 0);
        });


    }

    componentWillUpdate(nextProps, nextState, nextContext) {

        if (nextProps.filter.especieSeleccionada) {
            this.configSelectRadioGroupEspecie = {
                ...this.configSelectRadioGroupEspecie,
                selected: nextProps.filter.especieSeleccionada
            }
        }

        if (nextProps.filter.sexoSeleccionado) {
            this.configSelectRadioGroupSexo = {
                ...this.configSelectRadioGroupSexo,
                selected: nextProps.filter.sexoSeleccionado
            }
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {

        if (prevProps.avanzado !== this.props.avanzado) {
            if (this.props.avanzado) {
                let element = $('.avanzado');
                //console.log("Haciendo scrollTop");
                // $('body,html').stop(true, true).animate({scrollTop: element.offset().top}, 250);
            } else {
                let element = $('#animals-filter');
                //console.log("Haciendo scrollTop");
                // $('body,html').stop(true, true).animate({scrollTop: element.offset().top}, 250);
            }
            // this.onChangeFilter();
        }
    }

}

function mapStateToProps(state, ownProps) {
    const stateFilter = state[ownProps.filterControl]
    //TODO 22/4/24 19:08: remove this when global config is created
    const razasEspecieSelecionada = (stateFilter.especieSeleccionada !== "Ambos")?stateFilter.razasAnimales[stateFilter.especieSeleccionada]: [] || []
    return {
        // razasPerro: stateFilter.razasPerro,
        // razasGato: stateFilter.razasGato,
        // data: stateFilter["razas" + stateFilter.especieSeleccionada] || [],
        razasEspecieSelecionada: razasEspecieSelecionada,
        avanzado: stateFilter.avanzado,
        estadosAnimal: stateFilter.estadosAnimal,
        coloresAnimal: stateFilter.coloresAnimal,
        caractersAnimal: stateFilter.caractersAnimal,
        elementsPerRow: state.animals.elementsPerRow,
        elementsPerPage: state.animals.elementsPerPage,
        filter: stateFilter,
        totalRecord: (ownProps.filterControl === "filtersControlProtectora") ? state.animalsProtectora.totalRecord : state.animals.totalRecord,
        access: state.access
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    changeEspecieSeleccionada,
    changeSexoSeleccionado,
    changeTamaniosSeleccionado,
    resetTamaniosSeleccionado,
    changeEdadesSeleccionado,
    changeRazaSeleccionada,
    changeAvanzadoFilter,
    changeEstadoSeleccionado,
    changeEstadoUrgenteSeleccionado,
    changeColoresAnimalSeleccionados,
    changeCaractersAnimalSeleccionados,
    changeChipSeleccionado,
    changePPPSeleccionado,
    changeVacunaSeleccionada,
    loadRaza,
    loadEstadosAnimal,
    loadColoresAnimal,
    loadCaractersAnimal,
    changeEmailSubscription,
    changePostalCode,
    isLogin: checkIsLogin
})(AnimalFilter)
